/**
 * Collection Grid Section
 * Handles any interactive behavior for the collection grid
 */

class CollectionGrid {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Add any initialization logic here if needed
    // Currently the section is fully CSS-based
  }
}

// Initialize all collection grid sections
document.addEventListener('DOMContentLoaded', () => {
  const collectionGridSections = document.querySelectorAll('[data-section-type="collection-grid"]');
  collectionGridSections.forEach((section) => {
    new CollectionGrid(section);
  });
});

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="collection-grid"]')) {
      new CollectionGrid(event.target);
    }
  });
}
